module.exports=function(scope){ return `curl -X GET \
'https://your.internal.zoomserver.instance.url/enrollment/INSERT_ENROLLMENT_IDENTIFIER_HERE?return=faceMap,auditTrailImage' \
-H 'X-User-Agent: INSERT_X_USER_AGENT_VALUE_HERE'
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/bash/enrollment-get-facemap.bash.tpl